import Vue from 'vue'
import App from './App.vue'
import helpers from './helpers.js';
import bootstrap from './assets/bootstrap.min.css';
import styles from './assets/style.css';
import router from '@/router';
import store from '@/store';
import axios from 'axios';
import Ico from './components/Ico';
import { Observable,Queue } from './helperStructures.js'


import lang from '../../lang/vue-lang.js';
Vue.use(lang,{language:'pt-BR'});


import draggable from '@/draggable'
window.draggable = new draggable();


window.Vue = Vue;
Vue.config.productionTip = false

axios({
	method: 'get',
	url: '/api/user',
}).then((res)=>{
	store.dispatch('setUser',res.data)
	store.dispatch('authInitialized')
}).catch(()=>{
	store.dispatch('authInitialized')
}).finally(()=> {
	window.vm = new Vue({
		router,
		store,
		//lang,
		render: h => h(App),
	}).$mount('#app')
 });

